import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Divider,
    ListItem,
    ListItemText,
    List
} from '@mui/material';
import { IconUser, IconFileText } from '@tabler/icons-react';
import { useOrganogramContext } from './hooks/useOrganogramContext';

export function NodeModal() {
    const { selectedNode, isModalOpen, closeModal } = useOrganogramContext();

    return (
        <Dialog open={isModalOpen} onClose={closeModal} maxWidth="md" fullWidth>
            <DialogTitle>
                <Typography variant="h6">{selectedNode?.name}</Typography>
            </DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        py: 2
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 2
                            }}
                        >
                            <IconFileText size={20} />
                            <Typography variant="subtitle1" fontWeight="bold">
                                Descrição
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                bgcolor: 'grey.50',
                                p: 2,
                                borderRadius: 1,
                                minHeight: '100px'
                            }}
                        >
                            <Typography
                                sx={{
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    fontFamily: 'inherit'
                                }}
                            >
                                {selectedNode?.description ||
                                    'Sem descrição disponível'}
                            </Typography>
                        </Box>
                    </Box>

                    <Divider />

                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 2
                            }}
                        >
                            <IconUser size={20} />
                            <Typography variant="subtitle1" fontWeight="bold">
                                Dirigentes (
                                {selectedNode?.principals?.length || 0})
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                bgcolor: 'grey.50',
                                p: 2,
                                borderRadius: 1,
                                minHeight: '50px'
                            }}
                        >
                            {selectedNode?.principals &&
                                selectedNode.principals.length > 0 && (
                                    <Box sx={{ mt: 2 }}>
                                        <List>
                                            {selectedNode.principals.map(
                                                (p) => (
                                                    <ListItem
                                                        key={p.id}
                                                        disableGutters
                                                        sx={{
                                                            mb: 1,
                                                            p: 1,
                                                            border: '1px solid #ccc',
                                                            borderRadius: 1
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    fontWeight="bold"
                                                                >
                                                                    {p.name}
                                                                </Typography>
                                                            }
                                                            secondary={
                                                                <>
                                                                    <Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.primary"
                                                                    >
                                                                        {
                                                                            p
                                                                                .role
                                                                                ?.name
                                                                        }
                                                                    </Typography>
                                                                    <br />
                                                                    <Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                    >
                                                                        {
                                                                            p
                                                                                .role
                                                                                ?.description
                                                                        }
                                                                    </Typography>
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                )
                                            )}
                                        </List>
                                    </Box>
                                )}
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={closeModal}
                    sx={{ backgroundColor: '#3AAEAE' }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
